module.exports = __webpack_public_path__ + "img/View.5994b451.svg";